<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	nextArticleTitle: '',
	nextArticleLink: '',
	previousArticleTitle: '',
	previousArticleLink: '',
	seriesIndexPage: '',
	isFirst: false,
	isLast: false,
	publishDate: '',
	lastUpdated: '',
}
const schema = defineSchema({
	nextArticleTitle: $.text('Next Article Title'),
	nextArticleLink: $.text('Next Article Link'),
	previousArticleTitle: $.text('Previous Article Title'),
	previousArticleLink: $.text('Previous Article Link'),
	seriesIndexPage: $.text('Series Index Page'),
	isFirst: $.toggle('Is First'),
	isLast: $.toggle('Is Last'),
	publishDate: $.text('Publish Date'),
	lastUpdated: $.text('Last Updated'),
})
export const SeriesNavigation = defineBlock({ pickerHidden: true, thumbnail: '/block-thumbs/SeriesNavigation.svg', category: 'Layout', order: 340, name: 'SeriesNavigation', label: 'Series Navigation', icon: 'arrow_forward', schema, defaults })
</script>
<script setup lang="ts">


defineProps<{
	nextArticleTitle?: string
	nextArticleLink?: string
	previousArticleTitle?: string
	previousArticleLink?: string
	seriesIndexPage?: string
	isFirst?: boolean
	isLast?: boolean
	publishDate?: string
	lastUpdated?: string
}>()
</script>

<template>
	<div class="w720px  mx-auto ">
		<div v-if="isLast">
			<div v-if="publishDate || lastUpdated" class="color-gray-70 txt14 pb-2">
				<span v-if="publishDate" class="date-text">Published {{ publishDate }}</span>
				<span v-if="publishDate && lastUpdated" class="mx-1 m_mx-025">|</span>
				<span v-if="lastUpdated" class="date-text">Last Updated {{ lastUpdated }}</span>
			</div>
		</div>
		<nav class=" grid grid-wrap-2 gap-2">
			<!-- Previous Article -->
			<div v-if="previousArticleTitle">
				<p class="txt15">
					Previous in the Series
				</p>
				<RouterLink
					class=" decoration-none"
					:to="previousArticleLink || '/'"
				>
					<h4 class="txt21 bold line-height-14 m-0 pt-1">
						{{ previousArticleTitle }}
					</h4>
				</RouterLink>
			</div>

			<!-- Next Article -->
			<div v-if="nextArticleTitle">
				<p class="txt15">
					Next in the Series
				</p>
				<RouterLink
					class=" decoration-none"
					:to="nextArticleLink || '/'"
				>
					<h4 class="txt21 bold line-height-14 m-0 pt-1">
						{{ nextArticleTitle }}
					</h4>
				</RouterLink>
			</div>

			<!-- Donation section for last article -->
			<div v-if="isLast" class="donate-section">
				<p>
					If you enjoyed this series, please consider supporting our work.
				</p>
				<RouterLink to="/donate" class=" decoration-none color-primary pt-1 hover">
					Donate
				</RouterLink>
			</div>
		</nav>
	</div>
</template>
